import { IAction, IAsyncActionCreator, createAsyncActionCreator } from '../store/actions/createActionCreator';
import { IItemCacheThunkAction, IItemCacheDispatch } from '../store/actions/ItemCacheActions';
import { processBatch } from '../store/reducers/itemCacheReducer';

/**
 * @internal
 */
export interface IActionWithEffect {
  action: IAction;
  effect: IItemCacheThunkAction<void>;
}

/**
 * @internal
 */
export interface IProcessBatchWithEffectsPayload {
  actionsWithEffects: IItemCacheThunkAction<IActionWithEffect>[];
}

/**
 * Creates an action which, when dispatched, applies the given actions and effects in the correct order
 * for a transactional batch.
 *
 * @internal
 */
export const processBatchWithEffects: IAsyncActionCreator<IProcessBatchWithEffectsPayload, IItemCacheThunkAction<void>> =
  createAsyncActionCreator((payload: IProcessBatchWithEffectsPayload) => {
    return (dispatch: IItemCacheDispatch) => {
      const actions: IAction[] = [];
      const effects: IItemCacheThunkAction<void>[] = [];

      for (const {
        action,
        effect
      } of payload.actionsWithEffects.map((actionWithEffect: IItemCacheThunkAction<IActionWithEffect>) => {
        return dispatch(actionWithEffect);
      })) {
        actions.push(action);
        effects.push(effect);
      }

      dispatch(processBatch({
        actions
      }));

      for (const effect of effects) {
        dispatch(effect);
      }
    };
  });
